import React from "react"
import {Formik} from "formik"
import * as Yup from "yup"
import TextField from "../../../Address/Textfield"
import FullNameInput from "../../../FullName/FullName"
import DateField from "../../../DateField/DateField"
import moment from "moment"
import DocumentTypeHeader from "./DocumentTypeHeader"
import {ApplicationDocumentType} from "../../../../resources/application"
import {MatriculaConsularDocumentFormValues} from "./types"
import {birthDateValidation, fullNameValidation, validationErrorMessages} from "./validationSchemas"

interface MatriculaConsularDocumentFormProps {
	documentType: ApplicationDocumentType
	initialValues: MatriculaConsularDocumentFormValues
	onSubmit: (values: MatriculaConsularDocumentFormValues) => void
	formId: string
}

const validationSchema = Yup.object().shape({
	fullName: fullNameValidation,
	dateOfBirth: birthDateValidation,
	matriculaConsularId: Yup.string().required(validationErrorMessages.matriculaConsular.required),
})

export const MatriculaConsularDocumentForm = ({
	documentType,
	initialValues,
	onSubmit,
	formId,
}: MatriculaConsularDocumentFormProps) => {
	return (
		<Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
			{({values, handleChange, handleBlur, handleSubmit}) => (
				<form onSubmit={handleSubmit} id={formId} className="edit-document-form">
					<div className="key-value-card-container-key">Type</div>
					<DocumentTypeHeader documentType={documentType} />

					<div className="key-value-card-container-key">Name</div>
					<div className="form-row two">
						<FullNameInput fullName={values.fullName} handleChange={handleChange} handleBlur={handleBlur} />
					</div>

					<div className="key-value-card-container-key">Birth Date</div>
					<DateField
						name="dateOfBirth"
						label=""
						value={moment(values.dateOfBirth).format("YYYY-MM-DD")}
						onChange={handleChange}
						onBlur={handleBlur}
					/>

					<div className="key-value-card-container-key">Matricula Consular</div>
					<TextField
						className="input-blank-label"
						label=""
						placeholder="Enter matricula consular"
						name="matriculaConsularId"
						value={values.matriculaConsularId}
						onChange={handleChange}
						onBlur={handleBlur}
					/>
				</form>
			)}
		</Formik>
	)
}
